import { Contract, EPageViewType } from '../../types';
import { MeterPurchasePrices } from './MeterPurchasePrice';
import { OutOfHours } from './OutOfHours';
import { ServiceList } from './ServiceList';
import { useWatch } from 'react-hook-form';

interface ServiceDetailsTabProps {
  readonly: boolean;
  viewType: EPageViewType;
}

export const ServiceDetailsTab = ({ readonly, viewType }: ServiceDetailsTabProps) => {
  const contractType = useWatch<Contract, 'contractType'>({ name: 'contractType' });
  return (
    <div className="flex flex-col w-full">
      {contractType !== '100' && <OutOfHours viewType={viewType} readonly={readonly} />}
      <MeterPurchasePrices readonly={readonly} />
      <ServiceList readonly={readonly} viewType={viewType} />
      {/* Disabled DNO electrical checks for now since the table doesn't exist */}
      {/* {contractType === '100' && <DnoElectricalChecks readonly={readonly} />} */}
    </div>
  );
};
